// React
import { useContext } from "react"

// Components
import { DateInput } from "components"

// Contexts
import { DisabledContext } from "../contexts"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

export function Date(params: {
  disabled?: boolean
  name: string
}) {
  // Hooks
  const disabled = useContext(DisabledContext)

  // Form
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={params.name}
      render={({ field, fieldState }) => (
        <DateInput
          label="DATE"
          disabled={params.disabled || disabled}
          error={fieldState.error?.message}
          selected={moment(field.value).toDate()}
          onChange={(date) => {
            // Vars
            const selectedDate: string = moment(date).format("YYYY-MM-DD")

            field.onChange(selectedDate)
          }}
        />
      )}
    />
  )
}